'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Link from '@eliadmin/core/src/components/link';

import Image from '@eliadmin/core/src/components/image/image-wrapped';
import { Button } from '@eliadmin/core/src/components/ui/button';

import type { JobPortalOffer } from '@eliadmin/core/src/api/jobportal/offers-api';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { Heading } from '../../ui/heading';
import { MdOutlineEuro } from 'react-icons/md';
import { HiMapPin } from 'react-icons/hi2';

export interface OfferCardProps {
  offer: JobPortalOffer;
}

export const JobOfferCard = ({ offer }: OfferCardProps) => {
  const currency = useGlobalStore(s => s.generalLayout.currency);

  const imageSrc = offer.image?.url || offer.company?.image?.url || '/images/placeholder.png';

  return (
    <Link
      prefetch={false}
      href={offer?.slug ?? '#'}
      className="flex w-full flex-col items-start justify-start gap-6 rounded-[6px] border border-border p-4 transition-all hover:opacity-80 sm:items-end sm:p-5 lg:gap-8 lg:p-6"
    >
      <div className="flex w-full flex-col-reverse items-start justify-start gap-4 sm:flex-row sm:justify-between">
        <div className="flex w-full flex-col items-start justify-start gap-6">
          <div className="flex w-full flex-col items-start justify-start">
            <Heading title={offer?.name} tag="h4" />
            <p className="text-special-green text-xs -tracking-tight sm:text-sm">mojapraca.eu</p>
          </div>
          <div className="flex flex-col items-start justify-start gap-3">
            {!!offer?.min_salary && (
              <div className="flex items-center justify-start gap-2">
                <MdOutlineEuro size={20} className="text-primary" />
                <p className="text-sm -tracking-tight text-[#666666]">
                  od {offer?.min_salary} {currency}
                </p>
              </div>
            )}
            {!!offer?.country?.name && (
              <div className="flex items-center justify-start gap-2">
                <HiMapPin size={20} className="text-primary" />
                <p className="text-sm -tracking-tight text-[#666666]">{offer.country.name}</p>
              </div>
            )}
          </div>
        </div>
        <Image
          src={imageSrc}
          alt={resolveImageAlt((offer?.image?.url ? offer?.image : offer?.company?.image), offer?.name)}
          width={0}
          height={0}
          className="h-auto w-full max-w-[430px] overflow-hidden rounded-[6px] object-contain object-center sm:max-w-[280px]"
          sizes="( max-width: 640px ) 100vw, ( max-width: 1024px ) 50vw, 33vw"
        />
      </div>
      <Button className="w-full sm:w-fit">Detail pracovnej ponuky</Button>
    </Link>
  );
};
